// Key tokens of the tutorial texts ({fire}, {steer}…), replaced by the keys the player has actually bound.
import { kbd } from '../keyHints.js';
import type { GameAction } from '../../devices/input.js';

export const KEY_TOKENS: Record<string, readonly GameAction[]> = {
  steer: ['steerLeft', 'steerRight'],
  fire: ['fire'],
  gears: ['gearUp', 'gearDown'],
  gearUp: ['gearUp'],
  gearDown: ['gearDown'],
  look: ['look'],
  camera: ['camera'],
  pause: ['pause'],
};

/** Dictionary text with its key tokens turned into <kbd> of the current bindings. */
export const withKeys = (html: string): string => html.replace(/\{(\w+)\}/g, (m, k: string) => (KEY_TOKENS[k] ? kbd(...KEY_TOKENS[k]) : m));
